export const modalLayoutStyle = 'fixed bg-white'

export const dialogStyle =
  'w-[300px] text-center p-6 rounded-lg top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'
export const fullScreenStyle = 'max-w-[768px] w-full h-full inset-0 mx-auto'

export const bottomSheetStyle =
  'fixed bg-white rounded-t-[16px] left-[50%] translate-x-[-50%] bottom-0 max-w-[768px] w-full'
